import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService, PrimeTemplate } from 'primeng/api';
import { Local } from 'protractor/built/driverProviders';
import { interval } from 'rxjs';
import { ActiveSuppliers } from '../../Models/ActiveClasses';
import { AirlineMasterProperties } from '../../Models/AirlineMasterProperties';
import { BasicDataForChatRequired, ChatAppMessageProperties } from '../../Models/ChatAppProperties';
import { FlightSearchProperties } from '../../Models/FlightSearchProperties';
import {  OfflineSupplierProperties } from '../../Models/OfflineSupplierProperties';
import { AirlineMasterService } from '../../Services/airline-master.service';
import { OfflineNewVersionService } from '../../Services/offline-newVersion.service';
import { OfflinesuppliersService } from '../../Services/offlinesuppliers.service';
import { RevenueManagementService } from '../../Services/revenue-management.service';
import { OfflineBookingSourceProperties, OfflineNewVersionProperties, OfflinePassengerListProperties, OfflineSectorInformationNewVersion } from '../offlineNewProperties';
import { TicketSuppliersAccessCodeProperties } from '../../Models/GroupTicketProperties';
import { GroupTicketService } from '../../Services/groupTicket.service';
import { NavMenuComponent } from '../../nav-menu/nav-menu.component';
import { Bind } from 'primeng/bind';
import { Toast } from 'primeng/toast';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { ChatComponent } from '../../chat/chat.component';
import { Dialog } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { Select } from 'primeng/select';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-offline-ticket',
    templateUrl: './offline-ticket.component.html',
    styleUrls: ['./offline-ticket.component.css'],
    imports: [NavMenuComponent, Bind, Toast, ConfirmDialog, PrimeTemplate, ChatComponent, Dialog, FormsModule, Select, NgClass]
})
export class OfflineTicketComponent {
  viewprofile: boolean;


  constructor(private groupservice: GroupTicketService, private airlineservice: AirlineMasterService, private revenueService: RevenueManagementService, private offlineSupplierservice: OfflinesuppliersService, private service: OfflineNewVersionService, private router: Router, private confirmationService: ConfirmationService, private messageService: MessageService) {

  }
  airlineMasterinfo: AirlineMasterProperties[] = [];
  supplierList: ActiveSuppliers[] = [];
  offlineSupplierList: OfflineSupplierProperties[] = [];
  receivedData: ChatAppMessageProperties[] = [];
  previousStatus: number = 0;
  popupDepdetails: boolean = false;
  basicDataforChat = new BasicDataForChatRequired();
  loader: boolean = false;
  bookingId: number = 0;
  runningStatus: number = 0;
  request: string = "";
  type: string = "";
  intervalId: any;
  formsubmission: boolean = false;
  ticketProfile: boolean = false;
  isFormDisabled: boolean = false;
  forrequest: boolean = true;
  submithide: boolean = true;
  offlineObj = new OfflineNewVersionProperties();
  officeidListForBind: TicketSuppliersAccessCodeProperties[] = [];
  offlineBookingSource: OfflineBookingSourceProperties[] = [];
  ngOnInit() {
    this.GetOfflineSourceName();
    this.GetAirlineData();
    this.getOfflineSuppliers();
    this.request = localStorage.getItem('RequestActionOffline');
    this.basicDataforChat.property2 = this.request;
    if (this.request == null || this.request == undefined) {
      this.basicDataforChat.property2 = "User";
      this.request = "User";
    }


    let requestType = localStorage.getItem("RequestTypeOffline");
    this.type = requestType;
    if (requestType != "Create") {
      this.loader = true;
      this.basicDataforChat.property1 = (localStorage.getItem("offlineBookingId"));
      this.bookingId = Number(localStorage.getItem("offlineBookingId"));
      if (this.request == "Agent") {
        this.offlineObj.isManager = true;
        this.previousStatus = Number(localStorage.getItem("offlineBookingCurnStatus"));
        let offlineback = new OfflineNewVersionProperties();
        offlineback.inProgressTag = true;
        offlineback.offlineId = this.bookingId;
        offlineback.assignedUser = Number(localStorage.getItem("UserId"));;
       
        this.service.InProgressTag(offlineback).subscribe((data) => {
          this.loader = false;
          if (data.success) {
            this.intervalId = setInterval(() => {

              this.checkLastMessage();
            }, 300000);



            this.GetOfflineBookingById();
          }
          else {
            this.CheckROUTE();
          }
        });
      }
      else {
        this.submithide = true;
        this.isFormDisabled = true;
        this.intervalId = setInterval(() => {

          this.GetOfflineBookingById();

        }, 10000);

      }
    }
    else if (requestType == "Create") {
      this.submithide = false;
      this.forrequest = false;
      this.editProfileOpen(1);
    }
  }
   private GetOfflineSourceName = (): void => {
    this.service.GetOfflineBookingSource().subscribe((data) => {
      this.offlineBookingSource = data;
    });
  };
  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    if (this.request == "Agent") {

      let offlineback = new OfflineNewVersionProperties();
      offlineback.inProgressTag = false;
      offlineback.offlineId = Number(localStorage.getItem("offlineBookingId"));
      offlineback.assignedUser = 0;
      this.service.InProgressTag(offlineback).subscribe((data) => {
        this.loader = false;
        if (data.success) {

        }
      });
    }
    localStorage.removeItem('RequestActionOffline');
    localStorage.removeItem('RequestTypeOffline');
    localStorage.removeItem("offlineBookingId");
    localStorage.removeItem("requestingAgency");
    localStorage.removeItem("offlineBookingCurnStatus");
 
  }
  GetAirlineData() {
    this.airlineservice.getAirlinesData().subscribe((data) => {
      if (data.length > 0) {

        this.airlineMasterinfo = data;
      }
    })
  }
  getOfflineSuppliers() {
    this.offlineSupplierservice.getOfflineSupplier().subscribe((data) => {
      this.offlineSupplierList = data;
      this.getSuppliers();
    });
  }
  getSuppliers() {
    this.revenueService.GetRevenueManagementSupplierByParent(localStorage.getItem("AgencyId")).subscribe((result) => {
      this.supplierList = result;
      if (this.offlineSupplierList.length > 0) {
        if (this.supplierList == null || this.supplierList == undefined) {
          this.supplierList = [];
        }
        for (let i = 0; i < this.offlineSupplierList.length; i++) {
          let active = new ActiveSuppliers();
          active.name = this.offlineSupplierList[i].offlineSupplierName + " - " + this.offlineSupplierList[i].offlineProviderCode;
          active.supplierId = this.offlineSupplierList[i].offlineSupplierId;
          this.supplierList.push(active);
        }
      }
    });
  }
  private isValidAirline = (airline: string | undefined | null): boolean => {
    return airline !== null && airline !== undefined && airline.trim() !== "";
  };
  public OtherRequestCreateUpdate = (): void => {
    if (this.runningStatus ==0) {
      return;
    }
    this.offlineObj.requestingAgency = localStorage.getItem("AgencyId");
    this.offlineObj.resquestingUser = Number(localStorage.getItem("UserId"));
    this.offlineObj.offlineRequestType = Number(localStorage.getItem("RequestTypeIdFromOffline"));
    this.offlineObj.currentBookingStatus = this.runningStatus;
    this.service.OtherRequestCreateUpdate(this.offlineObj).subscribe((data) => {
      this.loader = false;
      if (data.success) {
        this.submithide = true;
        this.forrequest = true;
        this.ticketProfile = false;
        this.isFormDisabled = true;
        localStorage.setItem("RequestTypeOffline", "Update");
        this.basicDataforChat.property1 = data.data;
        console.log("create", this.basicDataforChat);
        this.bookingId = Number(data.data);
        localStorage.setItem("offlineBookingId", this.bookingId.toString());
        this.ngOnInit();
      }
      else {
        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: data.message });
      }
    });
  }
  public UpdateOfflineRequest = (status: number): void => {
    let offlineback = new OfflineNewVersionProperties();
    offlineback.assignedUser = Number(localStorage.getItem("UserId"));
    offlineback.currentBookingStatus = status;
    offlineback.previousBookingStatus = this.offlineObj.currentBookingStatus;
    offlineback.offlineId = this.offlineObj.offlineId;
    this.service.UpdateOfflineRequest(offlineback).subscribe((data) => {
      this.loader = false;
      if (data.success) {
        this.service.GetOfflineBookingById(this.bookingId).subscribe((data) => {
          this.loader = false;
          if (data != null && data != undefined) {
            this.offlineObj = data;
            localStorage.setItem("offlineBookingCurnStatus", this.offlineObj.currentBookingStatus.toString());
            if (status == 6) {
              this.messageService.add({ severity: 'success', summary: 'Successfully', detail: "Removed From List" });

            }
            else {
              this.messageService.add({ severity: 'success', summary: 'Successfully', detail: this.offlineObj.bookingStatusName });

            }
          }
        });

      }
      else {
        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: data.message });

      }
    });
  }
  handleData(data: any) {
    this.receivedData = data;

  }
  checkLastMessage() {
    //if (this.receivedData.length === 0 || this.basicDataforChat == null || this.basicDataforChat == undefined || this.basicDataforChat.property2 == null || this.basicDataforChat.property2 == undefined || this.basicDataforChat.property2 == "User") {

    //  return;
    //}
    //else if (this.request == "Agent") {
    //  const lastMessage = this.receivedData[this.receivedData.length - 1];
    //  if (lastMessage.creationDate == null) {
    //    return;
    //  }
    //  const lastMessageDate = new Date(lastMessage.creationDate);
    //  const currentDate = new Date();
    //  const timeDifference = currentDate.getTime() - lastMessageDate.getTime(); // in milliseconds
    //  const minutesDifference = timeDifference / (1000 * 60);
    //  if (minutesDifference > 5) {
    //    let offlineback = new OfflineNewVersionProperties();
    //    offlineback.inProgressTag = false;
    //    offlineback.offlineId = this.offlineObj.offlineId;
    //    offlineback.assignedUser = 0;
    //    this.service.InProgressTag(offlineback).subscribe((data) => {
    //      this.loader = false;
    //      if (data.success) {
    //        this.CheckROUTE();
    //      }
    //    });


    //  } else {
    //    console.log('Less than 5 minutes have passed. Staying on the current route.');
    //  }
    //}

    if (this.request == "Agent") {
      if (this.offlineObj.lastActivityTime == null) {
        return;
      }
      const lastMessageDate = new Date(this.offlineObj.lastActivityTime);
      const currentDate = new Date();
      const timeDifference = currentDate.getTime() - lastMessageDate.getTime(); // in milliseconds
      const minutesDifference = timeDifference / (1000 * 60);
      if (minutesDifference > 5) {
        this.confirmationService.confirm({
          header: 'Confirmation',
          message: 'You are working on this request?',
          acceptIcon: 'pi pi-check mr-2',
          rejectIcon: 'pi pi-times mr-2',
          rejectButtonStyleClass: 'p-button-sm',
          acceptButtonStyleClass: 'p-button-outlined p-button-sm',
          accept: () => {
            clearTimeout(timeoutHandler);
            let offlineback = new OfflineNewVersionProperties();
            offlineback.inProgressTag = true;
            offlineback.offlineId = this.bookingId;
            offlineback.assignedUser = Number(localStorage.getItem("UserId"));;
            this.service.InProgressTag(offlineback).subscribe((data) => {
              this.loader = false;
              if (data.success) {

              }
            });
          },
          reject: () => {
            clearTimeout(timeoutHandler);
            let offlineback = new OfflineNewVersionProperties();
            offlineback.inProgressTag = false;
            offlineback.offlineId = this.offlineObj.offlineId;
            offlineback.assignedUser = 0;
            this.service.InProgressTag(offlineback).subscribe((data) => {
              this.loader = false;
              if (data.success) {
                this.CheckROUTE();
              }
            });
          }
        });


        const timeoutHandler = setTimeout(() => {
          this.CheckROUTE();
        }, 60000);


      }
      else {
      }
    }
  }
  CheckROUTE() {
    let fromroute = localStorage.getItem('fromOfflineRequestRoute');
    if (fromroute == "managerOfflineRequestList") {

      this.router.navigateByUrl("/managerOfflineRequestList");
    }
    else {
      this.router.navigateByUrl("/offlineRequestList");
    }
   
  }
  GetOfflineBookingById() {
    this.service.GetOfflineBookingById(this.bookingId).subscribe((data) => {
      this.loader = false;
      if (data != null && data != undefined) {
        let userid = Number(localStorage.getItem("UserId"));
        this.offlineObj = data;
        this.changeBookingSource();
        if (this.offlineObj.currentBookingStatus == 1) {
          this.submithide = false;
          this.isFormDisabled = false;
        }
        else {
          this.isFormDisabled = true;
        }
        if (userid == this.offlineObj.assignedUser) {
          if ((this.previousStatus == this.offlineObj.currentBookingStatus) && this.offlineObj.inProgressTag) {
            this.offlineObj.bookingStatusName = "In Process";
           
           
           
          }
        }
        else if (this.request == "Agent") {
          this.CheckROUTE();
        }

      }
    });
  }
  changeBookingSource() {
    this.officeidListForBind = [];
    if (this.offlineObj.bookingSource.includes("OFS")) {
      let offlinepcc = this.offlineSupplierList.find(uy => uy.offlineSupplierId == this.offlineObj.bookingSource);
      for (let h = 0; h < offlinepcc.officeSupplierList.length; h++) {
        let ticketspprop = new TicketSuppliersAccessCodeProperties();
        ticketspprop.officeId = offlinepcc.officeSupplierList[h].offlinePcc;
        ticketspprop.currencyName = offlinepcc.officeSupplierList[h].currency;
        this.officeidListForBind.push(ticketspprop);

      }



    }
    else {
      this.groupservice.GetTicketAccessCode(this.offlineObj.bookingSource).subscribe(data => {
        this.officeidListForBind = data;


      });
    }
  }
  viewflight() {
    this.popupDepdetails = true;
  }
  editProfileOpen(num: number) {
    this.runningStatus = num;
    this.ticketProfile = true;
    if (this.offlineObj.currentBookingStatus == 1 && this.offlineObj.passengerList != null && this.offlineObj.passengerList.length==0) {
      this.addPassenger();
    }
    
  
  }
  viewProfileOpen() {
    this.viewprofile = true;
  }
  addPassenger() {
    if (this.offlineObj.passengerList.length<9) {
      let pass = new OfflinePassengerListProperties();
      this.offlineObj.passengerList.push(pass); 
    }
    
  }
  closeprofile() {
    this.router.navigateByUrl("/flightSearch");
  }
  removePassenger(index) {
    if (this.offlineObj.passengerList.length>1) {
      this.offlineObj.passengerList.splice(index,1);

    }
    
  }
}

